import React from 'react';
import { CheckIcon, LockIcon } from 'lucide-react';
export function Checkout() {
  const features = ['10 Módulos completos en PDF', '3 Bonos exclusivos (gratis hoy)', 'Plantillas editables listas para usar', 'Casos prácticos resueltos', 'Acceso inmediato y para siempre'];
  return <section id="compra" className="w-full max-w-4xl mx-auto px-4 py-12" data-id="element-38">
      <div className="bg-gradient-to-br from-emerald-50 to-teal-50 border-2 border-emerald-200 rounded-2xl p-8 md:p-12 shadow-xl" data-id="element-39">
        <div className="text-center mb-8" data-id="element-40">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-41">
            Conseguí tu Kit RRHH en Orden ahora
          </h2>
          <p className="text-lg text-gray-700" data-id="element-42">
            Todo lo que necesitás para gestionar RRHH sin errores ni riesgos
          </p>
        </div>

        <div className="bg-white rounded-xl p-6 mb-8 shadow-sm" data-id="element-43">
          <ul className="space-y-3" data-id="element-44">
            {features.map((feature, index) => <li key={index} className="flex items-center gap-3" data-id="element-45">
                <CheckIcon className="w-5 h-5 text-emerald-500 flex-shrink-0" data-id="element-46" />
                <span className="text-gray-700" data-id="element-47">{feature}</span>
              </li>)}
          </ul>
        </div>

        <div className="text-center mb-8" data-id="element-48">
          <div className="mb-4" data-id="element-49">
            <span className="text-gray-500 line-through text-2xl" data-id="element-50">$54.990</span>
          </div>
          <div className="text-5xl md:text-6xl font-bold text-gray-900 mb-2" data-id="element-51">
            $19.990
          </div>
          <p className="text-sm text-gray-600" data-id="element-52">
            Precio especial por tiempo limitado
          </p>
        </div>

        <a href="https://checkout.ebookpoint.shop/cart/59677762682961:1" className="block w-full bg-gradient-to-r from-emerald-500 to-teal-500 text-white text-center px-10 py-5 rounded-full text-xl font-bold hover:shadow-2xl hover:scale-105 transition-all duration-300 mb-4" data-id="element-53">
          Quiero mi pack RRHH ahora
        </a>

        <div className="flex items-center justify-center gap-2 text-sm text-gray-600" data-id="element-54">
          <LockIcon className="w-4 h-4" data-id="element-55" />
          <span data-id="element-56">Pago seguro • Entrega inmediata por email</span>
        </div>
      </div>
    </section>;
}